import { Component, OnInit } from '@angular/core';
import { ContentHeaderButton } from '../../models';
import { ContentHeaderBarService } from '../../header/content-header-bar/content-header-bar.service';
import { of, BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-navigation-demo',
  templateUrl: './navigation-demo.component.html',
  styleUrls: ['./navigation-demo.component.scss']
})
export class NavigationDemoComponent implements OnInit {
  alertVisible = true;
  alertDisabled = false;
  alertVisible$ = new BehaviorSubject<boolean>(true);
  alertDisabled$ = new BehaviorSubject<boolean>(false);
  title = 'Content Header Bar';
  subtitle = 'Subtitle';
  version = 'Version 7.8.24';

  buttons: ContentHeaderButton[] = [
    {
      name: 'Alert',
      color: 'warn',
      type: 'raised',
      icon: 'warning',
      onClick: () => {
        alert('Alert from Content Header Bar');
      },
      visible$: this.alertVisible$,
      disabled$: this.alertDisabled$
    },
    { name: 'Edit', color: 'primary', type: 'flat', icon: 'build' },
    { name: 'Save', color: 'accent', type: 'flat', separator: true },
    { separator: true },
    {
      name: 'Reset',
      color: 'accent',
      type: 'flat',
      disabled$: of(true),
      onClick: () => alert('Reset - should not happen, because it is disabled')
    },

    {
      name: 'Info',
      onClick: () => {
        alert('Info from Content Header Bar');
      }
    },
    {
      icon: 'favorite',
      color: 'primary',
      type: 'raised',
      onClick: () => {
        alert('icon only click');
      }
    }
  ];

  constructor(private headerBarService: ContentHeaderBarService) {}

  ngOnInit() {
    this.headerBarService.setButtons(this.buttons);
  }
}
